'use client';

import { useEffect, useState } from 'react';

import { BlogPostTeaser } from '~/components/blog/blog-post-teaser';
import { cn } from '~/lib/utils';
import { BlogTeaserFragment } from '~/server/generated/contentful-graphql';

const STORAGE_KEY = 'starlight_previous_post_id';
const RELATED_RENDER_MAX = 6;

export function RelatedPosts({
  posts,
  currentSlug,
  currentPostId,
  className,
}: {
  posts: BlogTeaserFragment[];
  currentSlug: string;
  currentPostId?: string | null;
  className?: string;
}) {
  const [previousId, setPreviousId] = useState<string | null>(null);

  useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) setPreviousId(stored);
    if (currentPostId) sessionStorage.setItem(STORAGE_KEY, currentPostId);
  }, [currentPostId]);

  const relatedPosts = posts
    .filter((post) => post.slug !== currentSlug && (!previousId || post.sys?.id !== previousId))
    .slice(0, RELATED_RENDER_MAX);

  if (relatedPosts.length === 0) return null;

  return (
    <div className={cn('container xl:max-w-7xl', className)}>
      <h2 className='heading-sm mb-5'>Related Starlight Stories</h2>
      <ul className='grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8'>
        {relatedPosts.map((post) => (
          <li key={post.slug}>
            <BlogPostTeaser post={post} />
          </li>
        ))}
      </ul>
    </div>
  );
}
